import SettingsScreen from './SettingsScreen'

export default SettingsScreen
